<template>
  <div class="data-field">
    <div class="data-field__title dea-heading--medium-xs">{{ title.toUpperCase() }}</div>
    <div class="data-field__content">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-if="field && field !== ' '" class="data-field__content-label dea-heading--regular-m" v-html="field"></div>
      <div v-else class="data-field__content-label" :class="placeholderClass">
        {{ label }}
      </div>
      <Links
        v-if="showLink"
        class="data-field__content-link dea-links--large dea-links--pointer"
        :class="`dea-links--${linkColor}`"
        @click="$emit('open-modify', { mail: field ? field : '', mode: emailMode })"
      >
        {{ link }}
      </Links>
    </div>
    <div class="data-field__remove-email">
      <Links
        v-if="showRemoveEmail && field"
        class="data-field__content-link dea-links--large dea-links--pointer"
        @click="$emit('open-modify', { mail: field, mode: 'delete' })"
      >
        Rimuovi email
      </Links>
    </div>
  </div>
</template>

<script>
import Links from "@/components/elements/Links";

export default {
  name: "DataField",
  components: { Links },
  props: {
    field: {
      type: String,
      default: "",
    },
    linkColor: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      required: "",
    },
    placeholderClass: {
      type: String,
      default: "dea-heading--regular-m",
    },
    showLink: {
      type: Boolean,
      default: false,
    },
    showRemoveEmail: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    emailMode() {
      if (this.field && this.field !== " ") {
        return "modify";
      }
      return "save";
    },
    label() {
      if (this.field && this.field !== " ") {
        return this.field;
      }
      return this.placeholder;
    },
    link() {
      if (this.field && this.field !== " ") {
        return "Modifica";
      }
      return "Aggiungi";
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.data-field {
  margin: $space-base 0;

  &__title {
    margin-bottom: $space-x-small;
  }

  &__content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  &__remove-email {
    display: flex;
    flex-direction: row-reverse;
  }
}
</style>
